
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import Pagination from 'react-bootstrap/Pagination';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { debounce } from 'lodash';
import { useToasts } from "react-toast-notifications";
import currency from 'currency.js';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/actions';
import './style.scss'

const Paginator = ({ page, total, handleFirstPage, handlePrevPage, handleManualPage, perPage, handleLastPage, handleNextPage }) => {
    return <Pagination
        style={{ justifyContent: "flex-end", alignItems: "center" }}
    >
        <span className="mr-3">
            {total} item{total > 1 ? "s" : ""}
        </span>
        <Pagination.First
            disabled={page > 1 ? false : true}
            className="mr-1"
            onClick={handleFirstPage}
        />
        <Pagination.Prev
            disabled={page > 1 ? false : true}
            onClick={handlePrevPage}
        />
        <div className="mx-2 d-flex flex-row align-items-center justify-content-center w-auto">
            <div className="mr-1" style={{ width: 35 }}>
                <input
                    type="text"
                    className="pagination-input"
                    onChange={handleManualPage}
                    value={page}
                />
            </div>
            of {Math.ceil(total / perPage)}
        </div>
        <Pagination.Next
            disabled={page < Math.ceil(total / perPage) ? false : true}
            onClick={handleNextPage}
        />
        <Pagination.Last
            disabled={page < Math.ceil(total / perPage) ? false : true}
            className="ml-1"
            onClick={handleLastPage}
        />
    </Pagination>;
};


const DownloadPostMedias = () => {
    const { addToast } = useToasts();

    const dispatch = useDispatch();

    const [searchBy, setSearchBy] = useState('login-email');
    const [users, setUsers] = useState([]);
    const [login, setLogin] = useState('');
    const [page, setPage] = useState(1);
    const [isBusy, setIsBusy] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [startSearch, setStartSearch] = useState(false);
    const [show, setShow] = useState(false);
    const [preparing, setPreparing] = useState(false);
    const [path, setPath] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [copyStatus, setCopyStatus] = useState('');
    const [numCopied, setNumCopied] = useState(0);
    const [percentage, setPercentage] = useState(0);

    const handleSelectedUser = (user) => {
        const index = selectedUsers.findIndex(selected => user.id == selected.id);
        const tmp = [...selectedUsers];
        if (index >= 0) {
            tmp.splice(index, 1);
        } else {
            tmp.push({ id: user.id, login: user.login });
        }

        setSelectedUsers([...tmp]);
    };

    useEffect(() => {
        if (startSearch) {
            getUsers();
        }
    }, [startSearch]);

    const [sort, setSort] = useState('asc');
    const [orderBy, setOrderBy] = useState('login');
    const getUsers = async () => {
        console.log({ selectedUsers });
        setIsBusy(true);
        await axios.get('/api/administration/download-post-medias', {
            params: {
                login,
                page,
                searchBy,
                per_page: perPage,
                sort,
                order_by: orderBy,
            }
        })
            .then(response => {
                setUsers(response.data.data);
                setIsBusy(false);
                setStartSearch(false);
                setTotal(response.data.total);
            });
    };

    const handleSearch = () => {
        setPage(1);
    };

    const SearchUserContainer = React.memo(({ login, setLogin, isBusy, selectedUsers, handleDownload, setStartSearch, preparing }) => {
        const [keyword, setKeyword] = useState('');

        useEffect(() => {
            setKeyword(login ?? '');
        }, []);

        const handleSearchClick = () => {
            setLogin(keyword);
            setStartSearch(true);
        };

        const clearSearchText = () => {
            setKeyword('');
        }

        return (
            <div className="my-2 mb-4">
                <div className="d-flex">
                    <div className="mr-1 top-3">
                        <input
                            type="text"
                            placeholder="Search username"
                            className="search-user-input"
                            onChange={e => setKeyword(e.target.value)}
                            value={keyword}
                        />
                        {
                            keyword && <i className="fal fa-times search-clear-icon" onClick={clearSearchText} />
                        }
                    </div>

                    <Button
                        variant="primary"
                        disabled={isBusy}
                        onClick={handleSearchClick}
                    >
                        {isBusy ? "Searching..." : "Search Users"}
                    </Button>

                    <button
                        className='btn btn-primary btn-sm mx-4'
                        onClick={handleDownload}
                        disabled={(selectedUsers && selectedUsers.length <= 0) || preparing}
                    >
                        <i className="fas fa-cloud-download-alt"></i> {preparing ? 'Preparing...' : 'Download'}
                    </button>
                </div>

                <div className="mt-1">
                    <div className="form-check form-check-inline">
                        <input
                            name="searchBy"
                            className="form-check-input"
                            type="radio"
                            id="searchByLogin"
                            value="login-email"
                            onChange={() => setSearchBy('login-email')}
                            checked={searchBy == 'login-email'}
                        />
                        <label className="form-check-label" htmlFor="searchByLogin">Login & Email</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            name="searchBy"
                            className="form-check-input"
                            type="radio"
                            id="searchByLogin"
                            value="login"
                            onChange={() => setSearchBy('login')}
                            checked={searchBy == 'login'}
                        />
                        <label className="form-check-label" htmlFor="searchByLogin">Login</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            name="searchBy"
                            className="form-check-input"
                            type="radio"
                            id="searchByEmail"
                            value="email"
                            onChange={() => setSearchBy('email')}
                            checked={searchBy == 'email'}
                        />
                        <label className="form-check-label" htmlFor="searchByEmail">Email</label>
                    </div>
                </div>
            </div>
        );
    });

    useEffect(() => {
        console.log({ users });
    }, [users]);

    const token = localStorage.getItem('loggedin_access_token');
    Pusher.logToConsole = true;
    const pusher = new Pusher(process.env.MIX_PUSHER_APP_KEY, {
        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        authEndpoint: '/broadcasting/auth',
        encrypted: true,
        auth: {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        },
    });

    const [email, setEmail] = useState('');
    const handleEmailChange = e => {
        setErrors({
            ...errors,
            email: ''
        });
        setEmail(e.target.value);
    };

    const [stats, setStats] = useState([]);
    const [maxSize, setMaxSize] = useState(100);
    const getStats = async () => {
        console.log({ selectedUsers });
        if (selectedUsers.length > 1) {
            alert('Only 1 user is supported at the moment');
            return;
        }

        setPreparing(true);
        await axios.get('/api/administration/download-post-medias/stats', {
            params: {
                ids: selectedUsers.map(selected => selected.id)
            }
        })
            .then(response => {
                setPreparing(false);
                setShow(true);
                setStats(response.data.details);
                setMaxSize(response.data.max_size);
            })
            .catch(error => {
                setPreparing(false);
            });
    };

    const [errors, setErrors] = useState({});
    const [proceed, setProceed] = useState(false);
    const [proceeding, setProceeding] = useState(false);
    const [completed, setCompleted] = useState([]);
    const [done, setDone] = useState(false);

    const handleDownload = async () => {
        if (selectedUsers.length > 1) {
            alert('Only 1 user is supported at the moment');
            return;
        }

        setPreparing(true);
        setProceeding(true);
        setErrors({});

        await axios.post('/api/administration/download-post-medias', {
            ids: selectedUsers.map(selected => selected.id),
            email
        }).then(response => {
            setPreparing(false);
            setProceed(true);
            setIsSubmitted(true);
        })
            .catch(error => {
                console.log({ error });
                setPreparing(false);
                setProceeding(false);
                if (error.response.status == 422) {
                    Object.keys(error.response.data.errors).forEach((key) => {
                        setErrors({
                            [key]: error.response.data.errors[key][0]
                        });
                    });
                } else {
                    addToast('Unable to proceed with the download', { appearance: 'error', autoDismiss: true });
                }
            });


        selectedUsers.forEach(user => {
            const channel = pusher.subscribe(`private-post-medias-download-${user.id}`);
            const self = this;
            channel.bind('App\\Events\\DownloadPostEvent', (d) => {
                console.log('*** pusher data: ', { d });
                handleCompleted(d);
            });
        });
    };

    const handleCompleted = (data) => {
        // setDone(true);
        // setIsSubmitted(false);
        setPath(data.path);
        setCopyStatus(data.status);
        setPercentage(data.percentage);
    };
    /*
        useEffect(() => {
            if (tmpState) {
                const tmpCompleted = [...completed];
                const index = tmpCompleted.findIndex(c => c.id == tmpState.id);

                if (index >= 0) {
                    tmpCompleted[index] = tmpState;
                } else {
                    tmpCompleted.push(tmpState);
                }

                setCompleted([
                    ...tmpCompleted
                ]);
            }
        }, [tmpState]); */

    useEffect(() => {
        console.log({ completed });
    }, [completed]);

    const handleHideModal = () => {
        selectedUsers.forEach(user => {
            pusher.unsubscribe(`private-post-medias-download-${user.id}`);
        });
        // setSelectedUsers([]);
        setShow(false);
        setCompleted([]);
        setEmail('');
        setErrors({});
        setProceed(false);
        setProceeding(false);
        setIsSubmitted(false);
        setPreparing(false);
        setPath('');
        setCopyStatus('');
        setPercentage(0);
    };

    const [total, setTotal] = useState(0);
    const [perPage, setperPage] = useState(25);
    const handleManualPage = e => {
        let value = Number.isInteger(parseInt(e.target.value.trim())) && parseInt(e.target.value.trim()) > 0
            ? parseInt(e.target.value.trim())
            : page;

        setPage(value);
    };

    const handlePrevPage = () => {
        setPage(page => page - 1);
    };

    const handleFirstPage = () => {
        setPage(1);
    };

    const handleNextPage = () => {
        setPage(page => page + 1);
    };

    const handleLastPage = () => {
        setPage(page => Math.ceil(total / perPage));
    };

    useEffect(() => {
        getUsers();
    }, [orderBy, sort]);

    useEffect(() => {
        handlePageChange(page);
    }, [page]);

    const handlePageChange = debounce(() => {
        getUsers();
    }, 800);

    useEffect(() => {
        setPage(1);
    }, [orderBy, sort]);

    const handleOrder = (e, column) => {
        e.preventDefault();
        if (column == orderBy) {
            if (sort == 'asc') {
                setSort('desc');
            } else {
                setSort('asc');
            }
        } else {
            setSort('asc');
        }
        setOrderBy(column);
    };

    useEffect(() => {
        if (selectedUsers.length > 0 && numCopied > 0) {
            let numImages = 0;
            const userDetails = stats.find(detail => detail.pu_id == selectedUsers[0].id);
            if (userDetails.images && userDetails.images.count) {
                numImages = userDetails.images.count;
            }
            let numVideos = 0;
            if (userDetails.videos && userDetails.videos.count) {
                numVideos = userDetails.videos.count;
            }

            const total = (numImages + numVideos);

            console.log('---------------------- numImages --------------------', numImages);
            console.log('---------------------- numVideos --------------------', numVideos);
            console.log('---------------------- TOTAL --------------------', total);

            if (numCopied >= total) {
                dispatch(setAlert({
                    show: true,
                    title: '',
                    body: `Post media download completed. Please view the media at this path ${path}`,
                    type: 'success'
                }));
            }
        }
    }, [numCopied]);


    return <div className="post-medias">
        <h3 className="mb-4">Download Post Medias</h3>
        <SearchUserContainer
            handleSearch={handleSearch}
            login={login}
            setLogin={setLogin}
            isBusy={isBusy}
            handleDownload={getStats}
            selectedUsers={selectedUsers}
            setStartSearch={setStartSearch}
            preparing={preparing}
        />

        <div className="row">
            <div className="col-md-6">
                <div className="my-3">
                    <Paginator
                        page={page}
                        total={total}
                        handleFirstPage={handleFirstPage}
                        handlePrevPage={handlePrevPage}
                        handleManualPage={handleManualPage}
                        perPage={perPage}
                        handleLastPage={handleLastPage}
                        handleNextPage={handleNextPage}
                    />
                </div>
                {isBusy && <div><Spinner variant="primary" animation="border" size="sm" /></div>}
                <table className="table table-sm table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th width="5%"></th>
                            <th>
                                <a href="#" onClick={e => handleOrder(e, 'login')}>
                                    <span style={{ color: "black" }}>Login
                                        {orderBy == 'login' && (
                                            <FontAwesomeIcon
                                                className="ml-2"
                                                color="#0097FE"
                                                icon={[
                                                    "fas",
                                                    sort === "desc"
                                                        ? "chevron-down"
                                                        : "chevron-up",
                                                ]} />
                                        )}
                                    </span>
                                </a>
                            </th>
                            <th>
                                <a href="#" onClick={e => handleOrder(e, 'id')}>
                                    <span style={{ color: "black" }}>ID
                                        {orderBy == 'id' && (
                                            <FontAwesomeIcon
                                                className="ml-2"
                                                color="#0097FE"
                                                icon={[
                                                    "fas",
                                                    sort === "desc"
                                                        ? "chevron-down"
                                                        : "chevron-up",
                                                ]} />
                                        )}
                                    </span>
                                </a>
                            </th>
                            <th>
                                <a href="#" onClick={e => handleOrder(e, 'email')}>
                                    <span style={{ color: "black" }}>Email
                                        {orderBy == 'email' && (
                                            <FontAwesomeIcon
                                                className="ml-2"
                                                color="#0097FE"
                                                icon={[
                                                    "fas",
                                                    sort === "desc"
                                                        ? "chevron-down"
                                                        : "chevron-up",
                                                ]} />
                                        )}
                                    </span>
                                </a>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            users?.map(user => {
                                return <tr key={user.id}>
                                    <td align="center">
                                        <input
                                            type="checkbox"
                                            id={`checkbox-${user.id}`}
                                            checked={selectedUsers.findIndex(selected => selected.id == user.id) >= 0}
                                            onChange={() => handleSelectedUser(user)}
                                        />
                                    </td>
                                    <td>
                                        {user.login}
                                    </td>
                                    <td>
                                        {user.id}
                                    </td>
                                    <td>{user.email}</td>
                                </tr>;
                            })
                        }

                        {
                            users && users.length <= 0 && !isBusy && <tr><td colSpan={4}>No data found</td></tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        <Modal
            show={show}
            onHide={handleHideModal}
            backdrop="static"
            keyboard={false}
            className="modal-download-post-medias"
        >
            <Modal.Header>
                <Modal.Title>Post Media Download</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ minHeight: 'auto' }}>
                <div className="alert">
                    <p>This process will copy production files into our mounted volume.</p>

                    {
                        copyStatus === 'fail' && <p className="text-danger">Failed to copy files.</p>
                    }
                </div>

                <ul>
                    {
                        selectedUsers.length > 0 && selectedUsers.map(user => {
                            const data = completed.find(c => c.id == user.id);
                            const userDetails = stats.find(detail => detail.pu_id == user.id);
                            const currencyOpt = { prcecision: 2, symbol: '' };
                            return <li key={user.id}> <b>{user.id} - {user.login}</b>&nbsp;
                                {isSubmitted && <div className="my-2">
                                    {
                                        numCopied < (parseInt(userDetails.videos.count) + parseInt(userDetails.images.count)) && <Spinner variant="primary" animation="border" size="sm" />
                                    }
                                    <em className="ml-1">{percentage}% Files copied</em>
                                    <br />
                                    Mount drive folder path: <b>{path}</b>
                                </div>}
                                {
                                    data && data.status && data.count > 0
                                        ? <ul>
                                            <li style={{ listStyle: 'none', marginLeft: '-40px' }}>Media statistics - total media {currency((userDetails.total / 1000000), currencyOpt).format()}mb</li>
                                            {userDetails.images.count > 0 && <li style={{ listStyle: 'none', marginLeft: '-40px' }}>{userDetails.images.count} images total size {currency((userDetails.images.size / 1000000), currencyOpt).format()}mb</li>}
                                            {userDetails.videos.count > 0 && <li style={{ listStyle: 'none', marginLeft: '-40px' }}>{userDetails.videos.count} videos total size {currency((userDetails.videos.size / 1000000), currencyOpt).format()}mb</li>}
                                        </ul>
                                        : ''
                                }

                                {
                                    !data && userDetails && <ul className='list-unstyled'>
                                        {userDetails.images.count > 0 && userDetails.videos.count > 0 &&
                                            <li>Media statistics - total media {currency((userDetails.total / 1000000), currencyOpt).format()}mb</li>
                                        }
                                        {userDetails.images.count > 0 && <li>{userDetails.images.count} images total size {currency((userDetails.images.size / 1000000), currencyOpt).format()}mb</li>}
                                        {userDetails.videos.count > 0 && <li>{userDetails.videos.count} videos total size {currency((userDetails.videos.size / 1000000), currencyOpt).format()}mb</li>}
                                        {
                                            userDetails.videos.count <= 0 && userDetails.images.count <= 0 && <li className="text-danger">User has no post files</li>
                                        }
                                    </ul>
                                }

                                {
                                    data && !data.status && <ul><li className="text-danger">Failed to generate download file</li></ul>
                                }
                            </li>;
                        })
                    }
                </ul>

                {/* {
                    (!isSubmitted || (isSubmitted && email)) && <div className="form-group">
                        <hr />
                        <label>Email to receive an alert when media are ready to view</label>
                        <input
                            type="email"
                            className={`form-control${errors.email ? ' is-invalid' : ''}`}
                            value={email}
                            onChange={handleEmailChange}
                            disabled={proceed}
                            required
                        />
                        {errors.email && <div class="invalid-feedback">{errors.email}</div>}
                    </div>
                } */}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleHideModal}>
                    {proceed ? 'Close' : 'Cancel'}
                </Button>
                {
                    !proceed && <Button variant="primary" onClick={handleDownload} disabled={proceeding}>
                        {proceeding ? 'Processing...' : 'Proceed'}
                    </Button>
                }

            </Modal.Footer>
        </Modal>
    </div>;
};

export default DownloadPostMedias;